import { getContrast } from 'polished';

export default function isWhitish(color: string) {
  return getContrast(color, '#fff') < 1.2;
}
